import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'TaskAssignment',
    column_type: 'id',
  },
  created_at: {
    model_name: 'TaskAssignment',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'TaskAssignment',
    column_type: 'datetime',
  },
  assignee: {
    model_name: 'TaskAssignment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'assignee',
      model_name: 'User',
    },
  },
  assignee_id: {
    model_name: 'TaskAssignment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'assignee',
      model_name: 'User',
    },
  },
  state: {
    model_name: 'TaskAssignment',
    column_type: 'enum',
  },
  reply: {
    model_name: 'TaskAssignment',
    column_type: 'text',
  },
  task_title: {
    model_name: 'TaskAssignment',
    column_type: 'string',
  },
  task: {
    model_name: 'TaskAssignment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'task',
      model_name: 'Task',
    },
  },
  task_id: {
    model_name: 'TaskAssignment',
    column_type: 'belongs_to',
    extra: {
      association_name: 'task',
      model_name: 'Task',
    },
  },
  customers_count: {
    model_name: 'TaskAssignment',
    column_type: 'integer',
  },
  followed_customers_count: {
    model_name: 'TaskAssignment',
    column_type: 'integer',
  },
  follow_ratio: {
    model_name: 'TaskAssignment',
    column_type: 'decimal',
  },
  follow_records: {
    model_name: 'TaskAssignment',
    column_type: 'has_many',
    extra: {
      association_name: 'follow_records',
      model_name: 'FollowRecord',
      foreign_key: 'task_assignment_id',
    },
  },
  follow_record_ids: {
    model_name: 'TaskAssignment',
    column_type: 'has_many',
    extra: {
      association_name: 'follow_records',
      model_name: 'FollowRecord',
      foreign_key: 'task_assignment_id',
    },
  },
  followed_customers: {
    model_name: 'TaskAssignment',
    column_type: 'string',
  },
  unfollowed_customers: {
    model_name: 'TaskAssignment',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
